require('../../modules/es7.object.get-own-property-descriptors');
module.exports = require('../../modules/_core').Object.getOwnPropertyDescriptors;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/object/get-own-property-descriptors.js
// module id = 277
// module chunks = 1